<div class="counter-header">
  <div class="counter-header__wrapper">
    <div class="counter-header__title">{{ 'RUN_PHASE.COUNTER' | translate }}</div>
    <div class="counter-header__counter">
      {{ counter | formatQuantity : false }}
      <span class="counter-header__unit">{{ counter.unitId | formatUnitId }}</span>
    </div>
  </div>
</div>
